import React from "react";
import {withStyles} from "@material-ui/core";
import MuiDialogActions from "@material-ui/core/DialogActions";

const DialogActions = withStyles((theme) => ({
    root: {
        margin: "0 0 1em 0",
        padding: theme.spacing(2),
    },
}))(MuiDialogActions);

const GenericDialogActions = (props) => {
    return (
        <DialogActions>
            {props.dialogActions}
        </DialogActions>
    )
}

export default GenericDialogActions;